<template lang="html">
  <div>
    <ul class="small-block" v-if="isCzjApp">
      <li class="part">
        <a href="javascript:;" class="linkedme">
          <star size="medium" :score="startLevelNum" color="#ffc600"></star>
          <p class="title">口碑</p>
        </a>
      </li>
      <li class="part">
        <a href="javascript:;" class="linkedme">
          <span class="txt"
            ><i>{{ shequUserInfo.comment_num }}</i
            >次</span
          >
          <p class="title">咨询</p>
        </a>
      </li>
      <li class="part">
        <a href="javascript:;" class="linkedme">
          <span class="txt"
            ><i>{{ shequUserInfo.fans_num }}</i
            >位</span
          >
          <p class="title">童粉</p>
        </a>
      </li>
    </ul>
    <ul class="small-block" v-else>
      <li class="part">
        <a href="javascript:;" class="linkedme">
          <star size="medium" :score="startLevelNum" color="#ffc600"></star>
          <p class="title">口碑</p>
        </a>
      </li>
      <li class="part">
        <a
          :href="`//shequ.cekid.com/bbs/user/${userInfo.uid}/qa?cmd=sqwd_person_answer&uid=${userInfo.uid}&nickname=${userInfo.name}`"
          class="linkedme"
          @click="track(23005)"
        >
          <span class="txt"
            ><i>{{ shequUserInfo.comment_num }}</i
            >次</span
          >
          <p class="title">咨询</p>
        </a>
      </li>
      <li class="part">
        <a
          :href="`//shequ.cekid.com/bbs/user/${userInfo.uid}?cmd=usercard&userType=0&userid=${userInfo.uid}&user=true`"
          class="linkedme"
          @click="track(23006)"
        >
          <span class="txt"
            ><i>{{ shequUserInfo.fans_num }}</i
            >位</span
          >
          <p class="title">童粉</p>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
import star from '@/components/common/star'

export default {
  props: {
    shequUserInfo: {
      type: Object
    },
    userInfo: {
      type: Object
    }
  },
  computed: {
    startLevelNum() {
      return this.userInfo.starLevel * 2
    },
    isCzjApp() {
      return this.$$isCZJApp()
    }
  },
  methods: {
    track(eventId, param) {
      this.$$tracker('140102', '20000', eventId, param)
    }
  },
  components: {
    star
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/mixin';

.small-block {
  display: flex;
  align-items: center;
  height: rem(132px);

  a {
    display: block;
    // padding-bottom: rem(20px);
    .txt {
      // padding-top: rem(16px);
    }
  }
  li {
    flex: 1;
    // height:rem(132px);
    .title {
      display: block;
      color: #999999;
      font-size: rem(24px);
      text-align: center;
    }
    .txt {
      display: block;
      color: #121212;
      font-size: rem(24px);
      text-align: center;
      i {
        font-size: rem(36px);
      }
    }
    .score {
      margin: rem(32px) auto rem(12px);
      padding-left: 0;
      width: rem(160px);
      display: block;
      overflow: hidden;
    }
  }
}
</style>
